import React from "react";
import { Button, Typography, Box } from "@material-ui/core";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    // Mantém o rastro no console mesmo em produção para facilitar o diagnóstico
    console.error("ErrorBoundary capturou um erro de render:", error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <Box
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          style={{ minHeight: "60vh", padding: 24, textAlign: "center" }}
        >
          <Typography variant="h5" gutterBottom>
            Ops! Algo deu errado ao carregar esta tela.
          </Typography>
          <Typography variant="body1" color="textSecondary" style={{ marginBottom: 24 }}>
            Tente recarregar a página. Se o problema persistir, contate o suporte.
          </Typography>
          <Button variant="contained" color="primary" onClick={this.handleReload}>
            Recarregar
          </Button>
          {process.env.NODE_ENV !== "production" && this.state.error && (
            <pre
              style={{
                marginTop: 24,
                maxWidth: "90vw",
                overflow: "auto",
                textAlign: "left",
                color: "#b00020",
              }}
            >
              {String(this.state.error?.stack || this.state.error)}
            </pre>
          )}
        </Box>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
